// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-event-container {
  container-type: inline-size;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 328px;
  min-height: 500px;
  box-sizing: border-box;
  background-color: var(--surface-primary);
}

.company-event-skeleton-loading-container {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
}

.company-event-body {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}

.company-event-list-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 0;
  overflow: hidden;
}

@container (min-width: 768px) {
  .company-event-list-panel {
    width: 50%;
    border-right: 1px solid var(--border-tertiary);
  }
}

.company-event-detail-panel {
  display: none;
  text-align: left;
}

@container (min-width: 768px) {
  .company-event-detail-panel {
    display: flex;
    width: 50%;
    height: 100%;
    overflow-y: auto;
    text-align: left;
  }
}

.event-list {
  flex: 1;
  overflow-y: auto;
  margin-bottom: 16px;
  margin-right: 8px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    height: 80px;
    background-color: var(--surface-disabled);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}

.event-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  margin-right: 8px;
  background-color: var(--row-light);
  cursor: pointer;
  outline: none;
  text-align: left;

  &:nth-child(even) {
    background-color: var(--row-dark);
  }

  &:hover {
    opacity: 0.8;
  }

  &:last-child {
    border-bottom: none;
  }
}

.event-item-type {
  color: var(--text-primary);
}

.event-item-description {
  color: var(--text-primary);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.event-item-date {
  color: var(--text-secondary);
  text-align: right;
  align-self: flex-end;
}
.event-pagination {
  margin-bottom: 24px;
}
.event-detail {
  padding: 0 16px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  text-align: left;
}

.event-detail-type {
  margin: 0;
  color: var(--text-secondary);
  border-bottom: 1px dashed var(--border-primary);
  height: 33px;
  display: flex;
  align-items: center;
}

.event-detail-title {
  margin: 16px 0 12px;
  color: var(--text-primary);
}

.event-detail-date {
  margin: 0 0 16px;
  color: var(--text-primary);
}

.event-detail-rows {
  display: flex;
  flex-direction: column;
}

.event-detail-row {
  display: flex;
  height: 32px;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  gap: 16px;
}

.event-detail-row-label {
  color: var(--text-label);
}

.event-detail-row-value {
  color: var(--text-primary);
  text-align: right;
}

.event-detail-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--text-ticker);
  cursor: pointer;
  text-decoration: none;
}
.event-detail-link:hover {
  color: var(--text-ticker);
}

.event-detail-link-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  path {
    fill: var(--text-ticker);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/CompanyEventWidget/CompanyEventWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,8CAA8C;EAChD;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;;EAEjB;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,gBAAgB;;EAEhB;IACE,iCAAiC;EACnC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,+CAA+C;EAC/C,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".company-event-container {\n  container-type: inline-size;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-width: 328px;\n  min-height: 500px;\n  box-sizing: border-box;\n  background-color: var(--surface-primary);\n}\n\n.company-event-skeleton-loading-container {\n  width: 100%;\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.company-event-body {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n}\n\n.company-event-list-panel {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n@container (min-width: 768px) {\n  .company-event-list-panel {\n    width: 50%;\n    border-right: 1px solid var(--border-tertiary);\n  }\n}\n\n.company-event-detail-panel {\n  display: none;\n  text-align: left;\n}\n\n@container (min-width: 768px) {\n  .company-event-detail-panel {\n    display: flex;\n    width: 50%;\n    height: 100%;\n    overflow-y: auto;\n    text-align: left;\n  }\n}\n\n.event-list {\n  flex: 1;\n  overflow-y: auto;\n  margin-bottom: 16px;\n  margin-right: 8px;\n\n  &::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    height: 80px;\n    background-color: var(--surface-disabled);\n    border-radius: 2px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n}\n\n.event-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px 16px;\n  margin-right: 8px;\n  background-color: var(--row-light);\n  cursor: pointer;\n  outline: none;\n  text-align: left;\n\n  &:nth-child(even) {\n    background-color: var(--row-dark);\n  }\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.event-item-type {\n  color: var(--text-primary);\n}\n\n.event-item-description {\n  color: var(--text-primary);\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.event-item-date {\n  color: var(--text-secondary);\n  text-align: right;\n  align-self: flex-end;\n}\n.event-pagination {\n  margin-bottom: 24px;\n}\n.event-detail {\n  padding: 0 16px;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  text-align: left;\n}\n\n.event-detail-type {\n  margin: 0;\n  color: var(--text-secondary);\n  border-bottom: 1px dashed var(--border-primary);\n  height: 33px;\n  display: flex;\n  align-items: center;\n}\n\n.event-detail-title {\n  margin: 16px 0 12px;\n  color: var(--text-primary);\n}\n\n.event-detail-date {\n  margin: 0 0 16px;\n  color: var(--text-primary);\n}\n\n.event-detail-rows {\n  display: flex;\n  flex-direction: column;\n}\n\n.event-detail-row {\n  display: flex;\n  height: 32px;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 0;\n  gap: 16px;\n}\n\n.event-detail-row-label {\n  color: var(--text-label);\n}\n\n.event-detail-row-value {\n  color: var(--text-primary);\n  text-align: right;\n}\n\n.event-detail-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-ticker);\n  cursor: pointer;\n  text-decoration: none;\n}\n.event-detail-link:hover {\n  color: var(--text-ticker);\n}\n\n.event-detail-link-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  path {\n    fill: var(--text-ticker);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
